import React from 'react'
import { connect } from 'react-redux'
import { Menu } from 'antd'
import { Link, withRouter } from 'react-router-dom'
import store from 'store'
import _ from 'lodash'
import CommonService from '../../../../services/commonService'
import urlConstant from '../../../../constants/urlConstant'
import styles from './style.module.scss'
import ProfileMenu from '../../TopBar/ProfileMenu'
// import UserFactory from '../../UserFactory'

const { SubMenu, Divider } = Menu

const mapStateToProps = ({ menu, settings }) => ({
  menuData: menu.menuTopData,
  isLightTheme: settings.isLightTheme,
  isSettingsOpen: settings.isSettingsOpen,
})

@withRouter
@connect(mapStateToProps)
class MenuTop extends React.Component {
  constructor(props) {
    super(props);
    this.CommonService = new CommonService();
  }

  state = {
    selectedKeys: store.get('app.menu.selectedKeys') || [],
  }

  componentWillMount() {
    this.setSelectedKeys(this.props)
    this.getTenantLogo() 

  }

  // componentDidMount() {
  // }

  componentWillReceiveProps(newProps) {
    this.setSelectedKeys(newProps)
  }

  setSelectedKeys = props => {
    const { menuData } = this.props
    const flattenItems = (items, key) =>
      items.reduce((flattenedItems, item) => {
        flattenedItems.push(item)
        if (Array.isArray(item[key])) {
          return flattenedItems.concat(flattenItems(item[key], key))
        }
        return flattenedItems
      }, [])
    const selectedItem = _.find(flattenItems(menuData, 'children'), [
      'url',
      props.location.pathname,
    ])
    this.setState({
      selectedKeys: selectedItem ? [selectedItem.key] : [],
    })
  }

  handleClick = e => {
    const { dispatch, isSettingsOpen } = this.props
    store.set('app.menu.selectedKeys', [e.key])
    if (e.key === 'settings') {
      dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'isSettingsOpen',
          value: !isSettingsOpen,
        },
      })
      return
    }
    this.setState({
      selectedKeys: [e.key],
    })
  }

  generateMenuItems = () => {
    const { menuData = [] } = this.props
    const generateItem = item => {
      const { key, title, url, icon, pro, disabled } = item
      if (item.divider) {
        return <Divider key={Math.random()} />
      }
      if (item.url) {
        return (
          <Menu.Item key={key} disabled={disabled}>
            {item.target ? (
              <a href={url} target={item.target} rel="noopener noreferrer">
                {icon && <span className={`${icon} ${styles.icon} cmsubmenulineheight`} />}
                <span className={styles.title}>{title}</span>
                {pro && <span className="badge badge-primary ml-2">PRO</span>}
              </a>
            ) : (
              <Link to={url}>
                {icon && <span className={`${icon} ${styles.icon}`} />}
                <span className={styles.title}>{title}</span>
                {pro && <span className="badge badge-primary ml-2">PRO</span>}
              </Link>
            )}
          </Menu.Item>
        )
      }
      return (
        <Menu.Item key={key} disabled={disabled}>
          {icon && <span className={`${icon} ${styles.icon}`} />}
          <span className={styles.title}>{title}</span>
          {pro && <span className="badge badge-primary ml-2">PRO</span>}
        </Menu.Item>
      )
    }
    const generateSubmenu = items =>
      items.map(menuItem => {
        if (menuItem.children && menuItem.children.length > 0) {
          const subMenuTitle = (
            <span className={styles.menu} key={menuItem.key}>
              <span className={styles.title}>{menuItem.title}</span>
              {menuItem.icon && <span className={`${menuItem.icon} ${styles.icon}`} />}
            </span>
          )
          return (
            <SubMenu title={subMenuTitle} key={menuItem.key}>
              {generateSubmenu(menuItem.children)}
            </SubMenu>
          )
        }
        return generateItem(menuItem)
      })
    return menuData.map(menuItem => {
      if (menuItem.children && menuItem.children.length > 0) {
        const subMenuTitle = (
          <span className={styles.menu} key={menuItem.key}>
            <span className={styles.title}>{menuItem.title}</span>
            {menuItem.icon && <span className={`${menuItem.icon} ${styles.icon} cm-submenu-lineheight`} />}
          </span>
        )
        return (
          <SubMenu title={subMenuTitle} key={menuItem.key}>
            {generateSubmenu(menuItem.children)}
          </SubMenu>
        )
      }
      return generateItem(menuItem)
    })
  }

  getTenantLogo = () => {
    const userData = JSON.parse(localStorage.getItem('webappuser'))
    const GetLogoURL =`${urlConstant.TenantConfig.GetTenantLogo}?TenantGuid=${userData.TenantGuid}`
    this.CommonService.httpGet(GetLogoURL, true)
    .then(response => {
      if (response.Value.Status === "Success") {
        this.setState({TenantLogobase64Url: response.Value.Data.TenantLogo});
      }
    }).catch(err => {
      console.log(err);
    })
  }

  render() {
    const { selectedKeys,TenantLogobase64Url } = this.state
    const { isLightTheme } = this.props
    // const userData = JSON.parse(localStorage.getItem('webappuser'))
    
    return (
      <div className={`row m-0 ${styles.cmHeader}`}>
        <div className={`${styles.logo} col-md-1 p-0`}>
          <div className={styles.logoContainer}>
            {TenantLogobase64Url ? 
              <img src={TenantLogobase64Url} alt="logo" />
              :
              <img src="resources/images/TLS/logo.png" alt="logo" />
            }
          </div>
        </div>
        <div className="col-md-11 d-flex">
          <Menu
            // theme={isLightTheme ? 'light' : 'dark'}
            theme={isLightTheme ? 'dark' : 'dark'}
            onClick={this.handleClick}
            selectedKeys={selectedKeys}
            mode="horizontal"
          >
            {this.generateMenuItems()}
          </Menu> 
          {/* {
            userData.role === "Auditor" &&
            <div className="ml-auto my-auto cm-header-select-box">
              <UserFactory />    
            </div>
          } */}
          <div className="ml-auto my-auto cm-my-ac">
            <ProfileMenu />    
          </div>
        </div>
      </div>
    )
  }
}

export default MenuTop